const SAFE_BLANK_FEATURES = "noopener,noreferrer";

/**
 * Ouvre une URL dans un nouvel onglet sans exposer window.opener (tabnabbing).
 */
export function safeWindowOpen(url: string, target: string = "_blank"): Window | null {
  if (!url) return null;
  return window.open(url, target, SAFE_BLANK_FEATURES);
}
